import { render, staticRenderFns } from "./ContentCatalogSimple.vue?vue&type=template&id=31c447cb&scoped=true&"
import script from "./ContentCatalogSimple.vue?vue&type=script&lang=js&"
export * from "./ContentCatalogSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c447cb",
  null
  
)

export default component.exports